<template>
  <div>
    <div class="back-title title-bar">
      <i class="el-icon-back c-pointer mr-r4" @click="clickBackButton"></i> 데이터소스 관리
    </div>
    <div class="mr-b25">
      <el-row class="title-bar" type="flex" justify="space-between">
        <div class="vertical-center-box">
          <div class="title-h4 mr-r15">데이터소스 목록</div>
          <div class="setting-addel">
            <el-button @click="clickAddButton"><i class="far fa-plus"/></el-button>
            <el-button @click="clickDeleteButton" :disabled="selectedRow==null"><i class="far fa-minus"/></el-button>
          </div>
        </div>
        <div class="vertical-center-box">
          <w-header-search-button size="mini" @click="setSearchToolVisible"></w-header-search-button>
        </div>
      </el-row>
      <el-table-wrapper :data="dataSourceTableData" :columns="dataSourceTableColumns" :column-default="columnDefault" ref="dataSourceTable" @row-click="clickRow" highlight-current-row :pagination="false" style="width:100%;"
        :show-search-tool="showSearchTool" :show-custom-header="true" height="265px">
      </el-table-wrapper>
    </div>
    <el-row class="title-bar">
      <div class="title-h4">데이터소스 상세정보</div>
    </el-row>
    <el-row>
      <el-form label-position="top" :model="dataSourceFormData" ref="dataSourceForm" :rules="rules">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="데이터소스 ID" prop="sourceId">
              <el-input v-model="dataSourceFormData.sourceId" placeholder="입력해 주세요." :disabled="selectedRow != null"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="데이터소스명" prop="sourceName">
              <el-input v-model="dataSourceFormData.sourceName" placeholder="입력해 주세요."></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="DB 종류" prop="sourceData.databaseType">
              <el-select v-model="dataSourceFormData.sourceData.databaseType" style="width:100%">
                <el-option v-for="item in dbTypeList" :key="item.basicinfoSubid" :label="item.basicinfoSubname" :value="item.basicinfoSubid"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="DB 주소" prop="sourceData.databaseConnectionAddress">
              <el-input v-model="dataSourceFormData.sourceData.databaseConnectionAddress" placeholder="입력해 주세요."></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="DB 포트" prop="sourceData.databaseConnectionPort">
              <el-input v-model="dataSourceFormData.sourceData.databaseConnectionPort" placeholder="입력해 주세요."></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="DB 명" prop="sourceData.databaseConnectionName">
              <el-input v-model="dataSourceFormData.sourceData.databaseConnectionName" placeholder="입력해 주세요."></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="USER ID" prop="sourceData.dabataseConnectionUserId">
              <el-input v-model="dataSourceFormData.sourceData.dabataseConnectionUserId" placeholder="입력해 주세요."></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="USER PASSWORD" prop="sourceData.databaseConnectionPassword">
              <el-input type="password" v-model="dataSourceFormData.sourceData.databaseConnectionPassword" placeholder="입력해 주세요."></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-row>
  </div>
</template>

<script>
import { cloneDeep, isNil, isEqual } from 'lodash';
import { columnDefault } from '@/constants/table';
import msgUtil from '@/utils/message';
import RscSettingsAPI from '@/api/settings/common/rsc-settings';
import BasicinfoSubAPI from '@/api/model/basicinfo-sub';

export default {
  name: 'WDataSourceSetting',
  watch: {
    selectedRow: {
      handler(object) {
        this.$refs.dataSourceTable.$children[0].setCurrentRow(object);
        if (!isNil(object)) {
          this.dataSourceFormData = cloneDeep(object);
        } else {
          this.$refs.dataSourceForm.resetFields();
          this.dataSourceFormData.sourceData = {};
        }
      },
    },
  },
  data() {
    const validateSourceId = (rule, value, callback) => {
      if (!isNil(this.selectedRow)) {
        callback();
      }
      if (isNil(value) || isEqual(value.length, 0)) {
        callback(new Error('필수 정보입니다.'));
      } else {
        RscSettingsAPI.checkSourceIdValidation({
          rscGetmethodId: 'SQL',
          sourceId: value,
        }).then((response) => {
          if (response.data.data) {
            callback();
          } else {
            callback(new Error('이미 사용 중인 ID입니다.'));
          }
        });
      }
    };
    return {
      showSearchTool: false,
      dbTypeList: [],
      dataSourceTableData: [],
      selectedRow: null,
      columnDefault,
      dataSourceTableColumns: [
        {
          prop: 'sourceId',
          label: '데이터소스 ID',
          searchable: true,
        },
        {
          prop: 'sourceName',
          label: '데이터소스명',
          searchable: true,
        },
      ],
      rules: {
        sourceId: {
          required: true,
          validator: validateSourceId,
          trigger: 'blur',
        },
        sourceName: {
          required: true,
          message: '필수 정보입니다.',
          trigger: 'blur',
        },
        'sourceData.databaseType': {
          required: true,
          message: '필수 정보입니다.',
          trigger: 'change',
        },
        'sourceData.databaseConnectionAddress': {
          required: true,
          message: '필수 정보입니다.',
          trigger: 'blur',
        },
        'sourceData.databaseConnectionPort': {
          required: true,
          message: '필수 정보입니다.',
          trigger: 'blur',
        },
        'sourceData.databaseConnectionName': {
          required: true,
          message: '필수 정보입니다.',
          trigger: 'blur',
        },
        'sourceData.dabataseConnectionUserId': {
          required: true,
          message: '필수 정보입니다.',
          trigger: 'blur',
        },
        'sourceData.databaseConnectionPassword': {
          required: true,
          message: '필수 정보입니다.',
          trigger: 'blur',
        },
      },
      dataSourceFormData: {
        sourceData: {},
      },
    };
  },
  mounted() {
    BasicinfoSubAPI.getList('DBTYPE').then((response) => {
      this.dbTypeList = response.data.data;
    });
  },
  methods: {
    loadData() {
      RscSettingsAPI.getRuleRscGetmethodSourceList().then((response) => {
        const result = response.data.data;
        if (!isNil(result)) {
          result.forEach((row) => {
            row.sourceData = JSON.parse(row.sourceData);
          });
          this.dataSourceTableData = result;
          this.$nextTick(() => {
            if (isNil(this.selectedRow)) {
              this.selectedRow = result[0];
            } else {
              this.dataSourceTableData.forEach((row) => {
                if (isEqual(row.sourceId, this.selectedRow.sourceId)) {
                  this.selectedRow = row;
                }
              });
            }
          });
        }
      });
    },
    setSearchToolVisible() {
      this.showSearchTool = !this.showSearchTool;
    },
    clickBackButton() {
      this.$emit('click-back-button');
    },
    clickAddButton() {
      this.selectedRow = null;
    },
    clickDeleteButton() {
      const tmepParam = {
        rscGetmethodId: this.selectedRow.rscGetmethodId,
        sourceId: this.selectedRow.sourceId,
      };
      RscSettingsAPI.checkRuleRscGetmethodSourceInUse(tmepParam).then((response) => {
        if (response.data.data) {
          this.$message(msgUtil.getCustomMsgData('현재 사용 중인 데이터소스는 삭제할 수 없습니다.'));
        } else {
          this.$confirm('삭제하시겠습니까?', '확인', {
            confirmButtonText: '확인',
            cancelButtonText: '취소',
          }).then(() => {
            const temp = this.selectedRow;
            temp.sourceData = JSON.stringify(temp.sourceData);
            RscSettingsAPI.deleteDataSource(temp).then(() => {
              this.selectedRow = null;
              this.loadData();
            });
          }).catch(() => {});
        }
      });
    },
    clickRow(row) {
      this.selectedRow = row;
    },
    saveButton() {
      this.$refs.dataSourceForm.validate().then((response) => {
        if (response) {
          const temp = cloneDeep(this.dataSourceFormData);
          temp.rscGetmethodId = 'SQL';
          temp.sourceData = JSON.stringify(temp.sourceData);
          if (isNil(this.selectedRow)) {
            RscSettingsAPI.insertDataSource(temp).then(() => {
              this.$message(msgUtil.getResultMsgData(msgUtil.action.MODIFY, '수집/판단 정보', true));
              this.loadData();
            });
          } else {
            RscSettingsAPI.updateDataSource(temp).then(() => {
              this.$message(msgUtil.getResultMsgData(msgUtil.action.MODIFY, '수집/판단 정보', true));
              this.loadData();
            });
          }
        }
      });
    },
    cancelButton() {
      if (isNil(this.selectedRow)) {
        this.$refs.dataSourceForm.resetFields();
      } else {
        this.dataSourceFormData = cloneDeep(this.selectedRow);
      }
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/settings/operation/BasicInfoSettings/CollectionJudgementRuleSettings/popup/DataSourceSetting.vue